"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const caretforward = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-caretforward` : '') + (description ? ` desc-caretforward` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-caretforward"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-caretforward"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.81207 22.9703L17.2914 13.1436L17.3877 13.0339C17.6246 12.735 17.75 12.3723 17.75 11.9981C17.75 11.5688 17.5851 11.1567 17.2909 10.8521L7.81207 1.02587L7.72448 0.946581C7.34724 0.655546 6.83602 0.692377 6.51432 1.02587L6.43355 1.1216C6.16434 1.48778 6.19126 2.01039 6.51432 2.34528L15.827 11.9981L6.51432 21.6509L6.43792 21.7416C6.16236 22.1254 6.19694 22.6413 6.51432 22.9703C6.87162 23.3407 7.45477 23.3407 7.81207 22.9703Z",
    fill: "inherit"
  }));
};
var _default = exports.default = caretforward;